import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { WalletService } from '../../services/wallet.service';
import {
  fetchSenderWalletList,
  loadedSenderWalletList,
  failedSenderWalletList,
  updateSenderWalletListFilter,
} from './sender-wallet-list.actions';
import { selectSenderWalletListFilter } from './sender-wallet-list.selector';

@Injectable()
export class SenderWalletListEffect {
  loadSenderWalletList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchSenderWalletList),
      switchMap(({ filter }) =>
        this.walletService.getSenderWalletList(filter).pipe(
          map(res => {
            if (res.success) {
              return loadedSenderWalletList({
                dataSource: {
                  totalRecords: res.response.totalRecords,
                  page: res.response.page,
                  count: res.response.count,
                  rawData: res.response.list,
                },
              });
            } else {
              return failedSenderWalletList();
            }
          }),
          catchError(() => of(failedSenderWalletList()))
        )
      )
    );
  });

  updateFilter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateSenderWalletListFilter),
      concatLatestFrom(() => this.store.select(selectSenderWalletListFilter)),
      switchMap(([action, prevFilter]) =>
        of(
          fetchSenderWalletList({ filter: { ...prevFilter, ...action.filter } })
        )
      )
    );
  });

  constructor(
    private store: Store,
    private readonly actions$: Actions,
    private readonly walletService: WalletService
  ) {}
}
